/** Comprehensive list of Material Icons (Google Fonts). */
export const MATERIAL_ICONS: string[] = [
  // Action
  '3d_rotation',
  'accessibility',
  'accessibility_new',
  'accessible',
  'account_balance',
  'account_balance_wallet',
  'account_box',
  'account_circle',
  'add_shopping_cart',
  'alarm',
  'alarm_add',
  'alarm_off',
  'alarm_on',
  'analytics',
  'android',
  'announcement',
  'api',
  'arrow_right_alt',
  'article',
  'aspect_ratio',
  'assessment',
  'assignment',
  'assignment_ind',
  'assignment_late',
  'assignment_return',
  'assignment_returned',
  'assignment_turned_in',
  'autorenew',
  'backup',
  'batch_prediction',
  'book',
  'bookmark',
  'bookmark_add',
  'bookmark_border',
  'bookmarks',
  'bug_report',
  'build',
  'build_circle',
  'cached',
  'calendar_today',
  'calendar_view_day',
  'calendar_view_month',
  'calendar_view_week',
  'cancel_schedule_send',
  'card_giftcard',
  'card_membership',
  'card_travel',
  'change_history',
  'check_circle',
  'check_circle_outline',
  'chrome_reader_mode',
  'class',
  'close_fullscreen',
  'code',
  'compare_arrows',
  'compress',
  'contact_mail',
  'contact_page',
  'contact_phone',
  'contactless',
  'copyright',
  'credit_card',
  'dangerous',
  'dashboard',
  'dashboard_customize',
  'data_exploration',
  'dataset',
  'date_range',
  'delete',
  'delete_forever',
  'delete_outline',
  'description',
  'disabled_by_default',
  'dns',
  'done',
  'done_all',
  'done_outline',
  'donut_large',
  'donut_small',
  'drag_indicator',
  'dynamic_form',
  'eco',
  'edit_calendar',
  'edit_off',
  'eject',
  'euro_symbol',
  'event',
  'event_seat',
  'exit_to_app',
  'explore',
  'explore_off',
  'extension',
  'face',
  'fact_check',
  'favorite',
  'favorite_border',
  'feedback',
  'filter_alt',
  'filter_alt_off',
  'find_in_page',
  'find_replace',
  'fingerprint',
  'first_page',
  'flight_land',
  'flight_takeoff',
  'forum',
  'forward_to_inbox',
  'g_translate',
  'gavel',
  'get_app',
  'grade',
  'grading',
  'group_work',
  'help',
  'help_center',
  'help_outline',
  'highlight_alt',
  'highlight_off',
  'history',
  'history_toggle_off',
  'home',
  'home_filled',
  'home_work',
  'horizontal_split',
  'hotel_class',
  'hourglass_bottom',
  'hourglass_disabled',
  'hourglass_empty',
  'hourglass_full',
  'hourglass_top',
  'http',
  'https',
  'important_devices',
  'inbox',
  'info',
  'input',
  'integration_instructions',
  'invert_colors',
  'label',
  'label_important',
  'label_important_outline',
  'label_off',
  'label_outline',
  'language',
  'last_page',
  'launch',
  'leaderboard',
  'light_mode',
  'line_style',
  'line_weight',
  'list_alt',
  'live_help',
  'lock',
  'lock_clock',
  'lock_open',
  'lock_outline',
  'login',
  'logout',
  'manage_accounts',
  'manage_search',
  'mark_as_unread',
  'maximize',
  'mediation',
  'minimize',
  'model_training',
  'next_plan',
  'no_accounts',
  'note_add',
  'notification_important',
  'offline_bolt',
  'offline_pin',
  'online_prediction',
  'opacity',
  'open_in_browser',
  'open_in_full',
  'open_in_new',
  'open_in_new_off',
  'open_with',
  'outbound',
  'outlined_flag',
  'padding',
  'paid',
  'pan_tool',
  'payment',
  'pending',
  'pending_actions',
  'perm_camera_mic',
  'perm_contact_calendar',
  'perm_data_setting',
  'perm_device_info',
  'perm_identity',
  'perm_media',
  'perm_phone_msg',
  'perm_scan_wifi',
  'pets',
  'picture_in_picture',
  'picture_in_picture_alt',
  'play_for_work',
  'polymer',
  'power_settings_new',
  'preview',
  'print',
  'privacy_tip',
  'published_with_changes',
  'query_builder',
  'question_answer',
  'question_mark',
  'quickreply',
  'quiz',
  'receipt',
  'receipt_long',
  'record_voice_over',
  'redeem',
  'remove_done',
  'remove_shopping_cart',
  'reorder',
  'report',
  'report_off',
  'report_problem',
  'request_page',
  'restore',
  'restore_from_trash',
  'restore_page',
  'rocket',
  'rocket_launch',
  'rounded_corner',
  'rowing',
  'rule',
  'satellite_alt',
  'saved_search',
  'schedule',
  'schedule_send',
  'search',
  'sell',
  'send',
  'settings',
  'settings_accessibility',
  'settings_applications',
  'settings_backup_restore',
  'settings_bluetooth',
  'settings_brightness',
  'settings_cell',
  'settings_ethernet',
  'settings_overscan',
  'settings_phone',
  'settings_power',
  'settings_remote',
  'settings_voice',
  'shopping_bag',
  'shopping_basket',
  'shopping_cart',
  'smart_button',
  'source',
  'space_dashboard',
  'star',
  'star_border',
  'star_half',
  'star_outline',
  'star_rate',
  'stars',
  'sticky_note_2',
  'store',
  'subject',
  'supervised_user_circle',
  'support',
  'support_agent',
  'swap_horiz',
  'swap_horizontal_circle',
  'swap_vert',
  'swap_vertical_circle',
  'system_update_alt',
  'tab',
  'task',
  'task_alt',
  'terminal',
  'theater_comedy',
  'thumb_down',
  'thumb_down_alt',
  'thumb_up',
  'thumb_up_alt',
  'thumbs_up_down',
  'timeline',
  'tips_and_updates',
  'title',
  'toc',
  'today',
  'toggle_off',
  'toggle_on',
  'token',
  'touch_app',
  'tour',
  'track_changes',
  'translate',
  'trending_down',
  'trending_flat',
  'trending_up',
  'troubleshoot',
  'unpublished',
  'update',
  'upgrade',
  'upload',
  'upload_file',
  'verified',
  'verified_user',
  'vertical_split',
  'view_agenda',
  'view_array',
  'view_carousel',
  'view_column',
  'view_comfy',
  'view_compact',
  'view_cozy',
  'view_day',
  'view_headline',
  'view_in_ar',
  'view_kanban',
  'view_list',
  'view_module',
  'view_quilt',
  'view_sidebar',
  'view_stream',
  'view_timeline',
  'view_week',
  'visibility',
  'visibility_off',
  'voice_over_off',
  'watch_later',
  'webhook',
  'wifi_protected_setup',
  'work',
  'work_history',
  'work_off',
  'work_outline',
  'wysiwyg',
  'youtube_searched_for',
  'zoom_in',
  'zoom_out',

  // Communication
  'alternate_email',
  'business',
  'call',
  'call_end',
  'call_made',
  'call_merge',
  'call_missed',
  'call_missed_outgoing',
  'call_received',
  'call_split',
  'chat',
  'chat_bubble',
  'chat_bubble_outline',
  'comment',
  'comments_disabled',
  'contacts',
  'dialpad',
  'document_scanner',
  'domain_verification',
  'duo',
  'email',
  'forward',
  'hourglass_bottom',
  'import_contacts',
  'import_export',
  'key',
  'list',
  'live_tv',
  'location_off',
  'location_on',
  'mail',
  'mail_lock',
  'mail_outline',
  'mark_chat_read',
  'mark_chat_unread',
  'mark_email_read',
  'mark_email_unread',
  'message',
  'mobile_off',
  'mobile_screen_share',
  'more',
  'network_check',
  'no_sim',
  'person_add_disabled',
  'phone',
  'phone_bluetooth_speaker',
  'phone_callback',
  'phone_disabled',
  'phone_enabled',
  'phone_forwarded',
  'phone_in_talk',
  'phone_iphone',
  'phone_locked',
  'phone_missed',
  'phone_paused',
  'phonelink_erase',
  'phonelink_lock',
  'phonelink_off',
  'phonelink_ring',
  'portable_wifi_off',
  'present_to_all',
  'question_answer',
  'read_more',
  'ring_volume',
  'rss_feed',
  'rtt',
  'screen_share',
  'send_time_extension',
  'sip',
  'speaker_phone',
  'spoke',
  'stay_current_landscape',
  'stay_current_portrait',
  'stop_screen_share',
  'swap_calls',
  'textsms',
  'unsubscribe',
  'videocam',
  'videocam_off',
  'voicemail',
  'volume_off',
  'wifi',
  'wifi_calling',
  'wifi_lock',
  'wifi_tethering',
  'wifi_tethering_error',
  'wifi_tethering_off',

  // Content
  'add',
  'add_box',
  'add_circle',
  'add_circle_outline',
  'add_link',
  'archive',
  'backspace',
  'ballot',
  'block',
  'calculate',
  'clear',
  'content_copy',
  'content_cut',
  'content_paste',
  'content_paste_go',
  'content_paste_off',
  'content_paste_search',
  'create',
  'delete_sweep',
  'drafts',
  'dynamic_feed',
  'file_copy',
  'filter_list',
  'filter_list_off',
  'flag',
  'font_download',
  'font_download_off',
  'gesture',
  'how_to_reg',
  'how_to_vote',
  'inventory',
  'inventory_2',
  'link',
  'link_off',
  'low_priority',
  'markdown',
  'markunread',
  'move_to_inbox',
  'next_week',
  'note_alt',
  'outlined_flag',
  'policy',
  'push_pin',
  'redo',
  'remove',
  'remove_circle',
  'remove_circle_outline',
  'reply',
  'reply_all',
  'save',
  'save_alt',
  'save_as',
  'select_all',
  'shield',
  'sort',
  'square_foot',
  'stacked_line_chart',
  'strikethrough_s',
  'subscript',
  'superscript',
  'table_chart',
  'table_rows',
  'table_view',
  'text_format',
  'text_snippet',
  'undo',
  'unarchive',
  'waves',
  'web',
  'weekend',
  'where_to_vote',

  // Device
  'access_alarms',
  'access_time',
  'access_time_filled',
  'add_alarm',
  'add_to_home_screen',
  'airplanemode_active',
  'airplanemode_inactive',
  'battery_alert',
  'battery_charging_full',
  'battery_full',
  'battery_saver',
  'bluetooth',
  'bluetooth_connected',
  'bluetooth_disabled',
  'bluetooth_drive',
  'bluetooth_searching',
  'brightness_auto',
  'brightness_high',
  'brightness_low',
  'brightness_medium',
  'data_saver_off',
  'data_saver_on',
  'data_usage',
  'developer_mode',
  'devices',
  'dvr',
  'flashlight_off',
  'flashlight_on',
  'gps_fixed',
  'gps_not_fixed',
  'gps_off',
  'graphic_eq',
  'grid_off',
  'grid_on',
  'location_disabled',
  'location_searching',
  'mode_night',
  'mode_standby',
  'my_location',
  'network_cell',
  'network_wifi',
  'nfc',
  'nightlight',
  'note',
  'notifications',
  'notifications_active',
  'notifications_none',
  'notifications_off',
  'notifications_paused',
  'power',
  'remember_me',
  'restart_alt',
  'screen_lock_landscape',
  'screen_lock_portrait',
  'screen_lock_rotation',
  'screen_rotation',
  'screenshot',
  'screenshot_monitor',
  'sd_storage',
  'send_to_mobile',
  'signal_cellular_4_bar',
  'signal_cellular_alt',
  'signal_cellular_off',
  'signal_wifi_4_bar',
  'signal_wifi_4_bar_lock',
  'signal_wifi_off',
  'sim_card',
  'sim_card_alert',
  'splitscreen',
  'storage',
  'summarize',
  'system_update',
  'tablet',
  'tablet_android',
  'tablet_mac',
  'thermostat',
  'time_to_leave',
  'tv_off',
  'usb',
  'usb_off',
  'vibration',
  'wallpaper',
  'widgets',
  'zoom_in_map',
  'zoom_out_map',

  // Editor
  'add_chart',
  'add_comment',
  'align_horizontal_center',
  'align_horizontal_left',
  'align_horizontal_right',
  'align_vertical_bottom',
  'align_vertical_center',
  'align_vertical_top',
  'area_chart',
  'attach_file',
  'attach_money',
  'bar_chart',
  'border_all',
  'border_bottom',
  'border_clear',
  'border_horizontal',
  'border_inner',
  'border_left',
  'border_outer',
  'border_right',
  'border_style',
  'border_top',
  'border_vertical',
  'bubble_chart',
  'candlestick_chart',
  'checklist',
  'checklist_rtl',
  'data_array',
  'data_object',
  'drag_handle',
  'drive_file_move',
  'drive_file_rename_outline',
  'drive_folder_upload',
  'edit',
  'edit_attributes',
  'edit_document',
  'edit_note',
  'edit_road',
  'emoji_flags',
  'emoji_food_beverage',
  'emoji_nature',
  'emoji_objects',
  'emoji_people',
  'emoji_symbols',
  'emoji_transportation',
  'euro',
  'expand',
  'file_present',
  'folder',
  'folder_copy',
  'folder_delete',
  'folder_off',
  'folder_open',
  'folder_shared',
  'folder_special',
  'folder_zip',
  'format_align_center',
  'format_align_justify',
  'format_align_left',
  'format_align_right',
  'format_bold',
  'format_clear',
  'format_color_fill',
  'format_color_reset',
  'format_color_text',
  'format_indent_decrease',
  'format_indent_increase',
  'format_italic',
  'format_line_spacing',
  'format_list_bulleted',
  'format_list_bulleted_add',
  'format_list_numbered',
  'format_overline',
  'format_paint',
  'format_quote',
  'format_shapes',
  'format_size',
  'format_strikethrough',
  'format_textdirection_l_to_r',
  'format_textdirection_r_to_l',
  'format_underlined',
  'functions',
  'height',
  'highlight',
  'horizontal_rule',
  'html',
  'image',
  'insert_chart',
  'insert_chart_outlined',
  'insert_comment',
  'insert_drive_file',
  'insert_emoticon',
  'insert_invitation',
  'insert_link',
  'insert_page_break',
  'insert_photo',
  'linear_scale',
  'map',
  'merge_type',
  'mode',
  'mode_comment',
  'mode_edit',
  'mode_edit_outline',
  'monetization_on',
  'money_off',
  'move_down',
  'move_up',
  'multiline_chart',
  'notes',
  'numbers',
  'pie_chart',
  'pie_chart_outline',
  'publish',
  'query_stats',
  'redo',
  'schema',
  'score',
  'short_text',
  'show_chart',
  'sort_by_alpha',
  'space_bar',
  'stacked_bar_chart',
  'table_chart',
  'text_decrease',
  'text_fields',
  'text_increase',
  'title',
  'toc',
  'type_specimen',
  'undo',
  'unfold_less',
  'unfold_more',
  'vertical_align_bottom',
  'vertical_align_center',
  'vertical_align_top',
  'wrap_text',

  // File
  'audio_file',
  'cloud',
  'cloud_circle',
  'cloud_done',
  'cloud_download',
  'cloud_off',
  'cloud_queue',
  'cloud_sync',
  'cloud_upload',
  'create_new_folder',
  'csv',
  'database',
  'file_copy',
  'file_download',
  'file_download_done',
  'file_download_off',
  'file_open',
  'file_present',
  'file_upload',
  'file_upload_off',
  'folder',
  'folder_copy',
  'folder_delete',
  'folder_off',
  'folder_open',
  'folder_shared',
  'folder_special',
  'folder_zip',
  'image',
  'insert_drive_file',
  'move_to_inbox',
  'new_label',
  'note',
  'note_add',
  'note_alt',
  'perm_media',
  'request_quote',
  'rule_folder',
  'snippet_folder',
  'source',
  'sticky_note_2',
  'topic',
  'upload',
  'upload_file',
  'workspaces',

  // Hardware
  'adb',
  'cable',
  'cast',
  'cast_connected',
  'cast_for_education',
  'charging_station',
  'computer',
  'connected_tv',
  'desktop_mac',
  'desktop_windows',
  'developer_board',
  'developer_board_off',
  'device_hub',
  'device_thermostat',
  'device_unknown',
  'devices',
  'devices_other',
  'dock',
  'earbuds',
  'earbuds_battery',
  'electrical_services',
  'garage',
  'headphones',
  'headphones_battery',
  'headset',
  'headset_mic',
  'headset_off',
  'home',
  'hub',
  'keyboard',
  'keyboard_alt',
  'keyboard_backspace',
  'keyboard_capslock',
  'keyboard_hide',
  'keyboard_return',
  'keyboard_tab',
  'keyboard_voice',
  'laptop',
  'laptop_chromebook',
  'laptop_mac',
  'laptop_windows',
  'memory',
  'microwave',
  'monitor',
  'mouse',
  'phone_android',
  'phone_iphone',
  'phonelink',
  'point_of_sale',
  'print',
  'router',
  'scanner',
  'security',
  'sim_card',
  'smart_display',
  'smart_screen',
  'smart_toy',
  'smartphone',
  'speaker',
  'speaker_group',
  'storage',
  'tablet',
  'tablet_android',
  'tablet_mac',
  'tv',
  'usb',
  'videogame_asset',
  'watch',

  // Maps
  'add_location',
  'add_location_alt',
  'alt_route',
  'atm',
  'attractions',
  'badge',
  'beenhere',
  'bike_scooter',
  'bus_alert',
  'car_crash',
  'car_rental',
  'car_repair',
  'celebration',
  'church',
  'clean_hands',
  'compass_calibration',
  'connecting_airports',
  'delivery_dining',
  'departure_board',
  'directions',
  'directions_bike',
  'directions_boat',
  'directions_bus',
  'directions_car',
  'directions_railway',
  'directions_run',
  'directions_subway',
  'directions_transit',
  'directions_walk',
  'edit_location',
  'edit_location_alt',
  'edit_road',
  'electric_bike',
  'electric_car',
  'electric_scooter',
  'emergency',
  'emergency_share',
  'ev_station',
  'explore',
  'fastfood',
  'festival',
  'flight',
  'forest',
  'fork_right',
  'free_breakfast',
  'gas_station',
  'handyman',
  'hardware',
  'holiday_village',
  'hospital',
  'hot_tub',
  'hotel',
  'layers',
  'layers_clear',
  'lightbulb',
  'local_activity',
  'local_airport',
  'local_atm',
  'local_bar',
  'local_cafe',
  'local_car_wash',
  'local_convenience_store',
  'local_dining',
  'local_drink',
  'local_fire_department',
  'local_florist',
  'local_gas_station',
  'local_grocery_store',
  'local_hospital',
  'local_hotel',
  'local_laundry_service',
  'local_library',
  'local_mall',
  'local_movies',
  'local_offer',
  'local_parking',
  'local_pharmacy',
  'local_phone',
  'local_pizza',
  'local_play',
  'local_police',
  'local_post_office',
  'local_printshop',
  'local_see',
  'local_shipping',
  'local_taxi',
  'location_city',
  'location_off',
  'location_on',
  'location_pin',
  'luggage',
  'lunch_dining',
  'map',
  'maps_home_work',
  'medical_services',
  'merge',
  'money',
  'moped',
  'motorcycle',
  'moving',
  'museum',
  'my_location',
  'navigation',
  'near_me',
  'near_me_disabled',
  'not_listed_location',
  'park',
  'pin_drop',
  'place',
  'restaurant',
  'restaurant_menu',
  'route',
  'run_circle',
  'sailing',
  'sanitizer',
  'set_meal',
  'share_location',
  'shortcut',
  'signpost',
  'sos',
  'spa',
  'sports_bar',
  'stadium',
  'storefront',
  'subway',
  'synagogue',
  'table_restaurant',
  'temple_buddhist',
  'terrain',
  'traffic',
  'train',
  'tram',
  'transfer_within_a_station',
  'trip_origin',
  'turn_left',
  'turn_right',
  'two_wheeler',
  'volunteer_activism',
  'water',

  // Navigation
  'apps',
  'arrow_back',
  'arrow_back_ios',
  'arrow_back_ios_new',
  'arrow_downward',
  'arrow_drop_down',
  'arrow_drop_down_circle',
  'arrow_drop_up',
  'arrow_forward',
  'arrow_forward_ios',
  'arrow_left',
  'arrow_right',
  'arrow_upward',
  'cancel',
  'check',
  'chevron_left',
  'chevron_right',
  'close',
  'double_arrow',
  'east',
  'expand_less',
  'expand_more',
  'fullscreen',
  'fullscreen_exit',
  'keyboard_arrow_down',
  'keyboard_arrow_left',
  'keyboard_arrow_right',
  'keyboard_arrow_up',
  'menu',
  'menu_open',
  'more_horiz',
  'more_vert',
  'north',
  'north_east',
  'north_west',
  'refresh',
  'south',
  'south_east',
  'south_west',
  'subdirectory_arrow_left',
  'subdirectory_arrow_right',
  'switch_left',
  'switch_right',
  'unfold_less',
  'unfold_more',
  'west',

  // Social
  'cake',
  'domain',
  'emoji_emotions',
  'engineering',
  'female',
  'fitness_center',
  'follow_the_signs',
  'group',
  'group_add',
  'group_off',
  'group_remove',
  'groups',
  'health_and_safety',
  'hiking',
  'interests',
  'king_bed',
  'mail',
  'man',
  'military_tech',
  'museum',
  'nature_people',
  'nightlife',
  'nordic_walking',
  'notification_add',
  'outdoor_grill',
  'pages',
  'park',
  'party_mode',
  'people',
  'people_alt',
  'people_outline',
  'percent',
  'person',
  'person_add',
  'person_add_alt',
  'person_add_alt_1',
  'person_off',
  'person_outline',
  'person_remove',
  'person_search',
  'poll',
  'psychology',
  'psychology_alt',
  'public',
  'public_off',
  'real_estate_agent',
  'recommend',
  'self_improvement',
  'share',
  'single_bed',
  'skateboarding',
  'sledding',
  'snowboarding',
  'social_distance',
  'sports',
  'sports_baseball',
  'sports_basketball',
  'sports_cricket',
  'sports_esports',
  'sports_football',
  'sports_golf',
  'sports_gymnastics',
  'sports_handball',
  'sports_hockey',
  'sports_kabaddi',
  'sports_martial_arts',
  'sports_mma',
  'sports_motorsports',
  'sports_rugby',
  'sports_score',
  'sports_soccer',
  'sports_tennis',
  'sports_volleyball',
  'surfing',
  'switch_account',
  'thumb_down',
  'thumb_down_alt',
  'thumb_up',
  'thumb_up_alt',
  'thumbs_up_down',
  'volunteer_activism',
  'woman',
  'work',

  // Places & Misc
  'apartment',
  'bathtub',
  'bento',
  'carpenter',
  'charging_station',
  'cottage',
  'countertops',
  'do_not_step',
  'do_not_touch',
  'doorbell',
  'fence',
  'fire_extinguisher',
  'food_bank',
  'foundation',
  'grass',
  'houseboat',
  'iron',
  'kitchen',
  'meeting_room',
  'microwave',
  'nature',
  'no_meeting_room',
  'other_houses',
  'pool',
  'roofing',
  'shower',
  'smoking_rooms',
  'snow',
  'soap',
  'stairs',
  'store_mall_directory',
  'umbrella',
  'villa',
  'wash',
  'water_damage',
  'yard',

  // Data & Analytics
  'account_tree',
  'auto_graph',
  'bar_chart',
  'bubble_chart',
  'candlestick_chart',
  'donut_large',
  'donut_small',
  'insights',
  'join_full',
  'join_inner',
  'join_left',
  'join_right',
  'line_axis',
  'multiline_chart',
  'pie_chart',
  'pie_chart_outline',
  'query_stats',
  'schema',
  'show_chart',
  'stacked_bar_chart',
  'stacked_line_chart',
  'table_chart',
  'timeline',
  'waterfall_chart',
]
  .sort()
  .filter((v, i, a) => a.indexOf(v) === i);
